'use strict';

const _=require('pulsar-utils/dist-es6/_');
const SortExtensions=require('../../../../../dist-es6/client/extensions/sortExtensions');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DashboardListDirective=class DashboardListDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'dashboardDataService',
'searchQuery',
'filteredPersons',
'sortByFatigueScore',
'sortByFatigueAlertType',
'selectedGroupData',
'selectedNotificationType'];

}

get templateUrl(){
return'/templates/features/dashboard/components/dashboardListView';
}

get controller(){
return DashboardListController;
}};let


DashboardListController=class DashboardListController{
constructor(timeFormattingService){
this._timeFormattingService=timeFormattingService;

this._sortByDescendingFatigueScore=SortExtensions(this.sortByFatigueScore).invert();

this.tableColumnDefinitions=[{
label:'Name',
defaultAscending:!0,
orderBy:['name'],
finalSort:[this._sortByDescendingFatigueScore],
columnClass:'name-column'},
{
label:'Alert',
isInitiallyActive:!0,
defaultAscending:!1,
orderBy:[this.sortByFatigueAlertType],
finalSort:[this._sortByDescendingFatigueScore,'name'],
columnClass:'deviation-column'},
{
label:'Fatigue',
defaultAscending:!1,
orderBy:[this.sortByFatigueScore],
finalSort:['name'],
columnClass:'fatigue-column'},
{
label:'Status',
defaultAscending:!0,
orderBy:['lastKnownDutyStatus'],
finalSort:[this._sortByDescendingFatigueScore,'name'],
columnClass:'duty-status-column'},
{
label:'Location',
defaultAscending:!0,
orderBy:['lastKnownLocationDescription'],
finalSort:[this._sortByDescendingFatigueScore,'name'],
columnClass:'last-location-column'},
{

columnClass:'filler-column'}];

}

get timeFormattingService(){
return this._timeFormattingService;
}};


module.exports=DashboardListDirective;
//# sourceMappingURL=dashboardListDirective.js.map
